module.exports = __webpack_public_path__ + "4913415f58a3858c41c89252074626f7.svg";